export default "__VITE_ASSET__DoUXbza6__"